export const T = {
  paper: "#E9EAE4",
  surface: "#FFFFFF",
  ink: "#1B2430",
  inkSoft: "#5A6472",
  inkFaint: "#8A93A0",
  line: "#DCDED6",
  lineStrong: "#C4C8BD",
  pine: "#28614F",
  pineSoft: "#E4EDE9",
  danger: "#8C3A2B",
  dangerSoft: "#F6E9E6"
};

export const display = `"Iowan Old Style", "Palatino Linotype", Palatino, Charter, Georgia, serif`;
export const body = `system-ui, -apple-system, "Segoe UI", Roboto, sans-serif`;
export const mono = `ui-monospace, "SF Mono", "JetBrains Mono", Menlo, Consolas, monospace`;
